import { Head } from "@inertiajs/react"
import { CompanyLayout } from "~/components/company/CompanyLayout"
import { HeroSection } from "~/components/company/sections/HeroSection"
import { ServicesOverviewSection } from "~/components/company/sections/ServicesOverviewSection"
import { WhoWeHelpSection } from "~/components/company/sections/WhoWeHelpSection"
import { WhyUsSection } from "~/components/company/sections/WhyUsSection"
import { ProofSection } from "~/components/company/sections/ProofSection"
import { ProcessSection } from "~/components/company/sections/ProcessSection"
import { FinalCTASection } from "~/components/company/sections/FinalCTASection"
import { TechnologyStackSection } from "~/components/company/sections/TechnologyStackSection"
import { FAQSection } from "~/components/company/sections/FAQSection"
import { ContactSection } from "~/components/company/sections/ContactSection"

export default function Home() {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <CompanyLayout>
      <Head>
        <title>Optimal Dev Labs | Build Faster. Automate More. Hire Less.</title>
        <meta name="description" content="MVP development in 30 days. AI workflow automation. Engineering team extension. We help startups and teams ship products fast without hiring." />
        <meta property="og:title" content="Optimal Dev Labs | Build Faster. Automate More. Hire Less." />
        <meta property="og:description" content="MVP development in 30 days. AI workflow automation. Engineering team extension. We help startups and teams ship products fast without hiring." />
        <meta property="og:url" content="https://optimaldevlabs.com" />
        <link rel="canonical" href="https://optimaldevlabs.com" />
      </Head>
      <HeroSection onContactClick={scrollToContact} />
      <ServicesOverviewSection />
      <WhoWeHelpSection />
      <WhyUsSection />
      <ProofSection />
      <ProcessSection />
      <FinalCTASection onContactClick={scrollToContact} />
      <TechnologyStackSection />
      <FAQSection />
      <ContactSection />
    </CompanyLayout>
  )
}
